import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../../data/content";

export default function MarqueeStrip() {
  return (
    <section data-testid="marquee-section" className="relative py-6 border-y border-white/10 bg-gk-panel/40 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-cinzel text-2xl md:text-3xl tracking-wide mx-6 ${i % 2 === 0 ? "marquee-word solid" : "marquee-word"}`}
            >
              {w}
            </span>
            <span className="text-gk-gold text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
